export const SET_HEADER_VISIBILITY = 'SET_HEADER_VISBILITY';
export const APPLY_OFFER = 'APPLY_OFFER';
export const CONTACT = 'CONTACT';
